<template>
  <div class=" is-fullwidth">
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th  >PO Number
            
          </th>
   	 		<th >Customer
           
          </th>
          <th>Garment
          
          </th>
          <th>Range</th>
          <th >Delivery
            
          </th>
          <th>Qty</th>
          <th width="130">&nbsp;</th>
           <th width="130">&nbsp;</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="9" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="9" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td > <div class="tag is-success" v-if="order.embroidery_approved==1">{{order.ponumber}}</div>
              <span v-if="order.embroidery_approved==0">{{order.ponumber}}</span>
            </td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.range_name}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td><button class="button is-small is-link" @click="showEmbroideryModal(order)" >View Details</button></td>
          <td><button class="button is-small is-success" @click="completeOrder(order)" v-if="order.status==1">Complete</button></td>
              
			</tr>
    	</tbody>
    </table>
    
    <EmbroideryModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID" :showAddButtons="showAddButtons" @updateOrderApproved="updateOrderApproved"/>
    
    
  </div>
</template>

<script>
import EmbroideryModal from '@/components/Offshore/EmbroideryModal';

import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
    EmbroideryModal
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: '',
      showAddButtons: true,
      accessToken: '',
      search: ''
    }
  },
   methods: {
    showEmbroideryModal(order) {
      this.selectedOrderID = order.orderID
     
        this.showModal = true
    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getOffshoreEmbroideryOrdersForStrabane(this.accessToken) 
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      updateOrderApproved() {
        this.orders.forEach(order => {
          if (order.orderID === this.selectedOrderID) {
            order.embroidery_approved = true; // or any other value you need to set
          }
        });
      },
      async completeOrder(order) {
          this.working = true
          if(confirm("Are you sure you want to record that the embroidery for this order has been completed in Strabane ?"))
          {
            var formdata = { 
              _method: 'patch',
              status: 2
            }; 

            OrderService.updateEmbroideryRequestStrabane(this.accessToken, order.embroidery_request_id, formdata)
              .then(() => {
              order.status = 2
              this.working = false
              //console.log(response)
            }).catch((error) => {
              alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
            });
          }
          else{
            this.working = false
            return false
          }

          
       
      },
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function() { // Rmeoved u from parameters
            //if(  u.in_progress == 0) 
           // {
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
         {
           filteredOrders = filteredOrders.filter(row => 
           row.ponumber.toLowerCase().includes(this.search.toLowerCase())
            || row.clientname.toLowerCase().includes(this.search.toLowerCase())
            || row.garmentname.toLowerCase().includes(this.search.toLowerCase())

          )
         }
          

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }
      
  },
  watch: {
    makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

